import script from "./player.vue?vue&type=script&setup=true&lang=ts"
export * from "./player.vue?vue&type=script&setup=true&lang=ts"

import "./player.vue?vue&type=style&index=0&id=07f408ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07f408ee"]])

export default __exports__